import React, { useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import { defineMessages, useIntl } from 'react-intl';
import { useHistory } from 'react-router-dom';

import AdvancedHotkey from './component';

export const messages = defineMessages({
  name: {
    description: 'navigationHotkeys.ShipstationConnectSettings',
    defaultMessage: 'ShipStation Connect Settings',
    id: 'Lmm+JF',
  },
});

export const hotkey = ['g', 'a', 'n'];
export const barcodeContent = '+5J8HELMTEM5Y=';

const GotoShipstationConnectSettings = ({ children }) => {
  const intl = useIntl();
  const history = useHistory();
  const handler = useCallback(() => history.push('/settings/connect'), [history]);
  const hotkeyMetadata = useMemo(
    () => ({
      barcode: barcodeContent,
      displayHotkeyStrings: ['gan'],
      hotkey,
      handler,
      name: intl.formatMessage(messages.name),
      legacyCategory: 'navigation',
      isGlobal: true,
    }),
    [intl, handler],
  );

  return <AdvancedHotkey hotkey={hotkeyMetadata}>{children}</AdvancedHotkey>;
};

GotoShipstationConnectSettings.propTypes = {
  children: PropTypes.node.isRequired,
};

export default GotoShipstationConnectSettings;
